/**
 * The double opt-in email sends subscribers back to the site with
 * `?confirmed=1` once they click the link. Detecting it lets us show a
 * confirmation instead of the signup form they just completed.
 *
 * Configured on the provider's list: point the post-confirmation redirect at
 * `https://creorank.com/?confirmed=1`.
 */
const CONFIRMED_PARAM = 'confirmed';

export function hasConfirmedFlag(search: string = window.location.search): boolean {
  return new URLSearchParams(search).has(CONFIRMED_PARAM);
}
